import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useInvoiceItems} from '../hooks/useInvoiceItems.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
    DataTableTokenPagination,
} from '@flexinet/ui-components';

interface RecordsTableProps {
    invoiceId?: string;
}

export const RecordsTable = ({invoiceId}: RecordsTableProps) => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useInvoiceItems(invoiceId);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {columns} = useTableColumns({onRecordClick: () => {}});

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination loadedCount={totalCount} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
